export const LINKEDIN_PROVIDER_ID = 'linkedin';
const LINKEDIN_REDIRECT_PENDING_KEY = 'capgo_social_login_linkedin_redirect';
const LINKEDIN_AUTH_URL = 'https://www.linkedin.com/oauth/v2/authorization';
const LINKEDIN_TOKEN_URL = 'https://www.linkedin.com/oauth/v2/accessToken';
const LINKEDIN_RESOURCE_URL = 'https://api.linkedin.com/v2/userinfo';
const LINKEDIN_DEFAULT_SCOPE = 'openid profile email';
const normalizeScope = (scope) => {
    if (!scope)
        return LINKEDIN_DEFAULT_SCOPE;
    if (Array.isArray(scope)) {
        return scope.filter(Boolean).join(' ');
    }
    return scope;
};
export const buildLinkedInOAuthConfig = (config) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const scope = normalizeScope((_a = config.scope) !== null && _a !== void 0 ? _a : config.scopes);
    return Object.assign(Object.assign({}, config), { appId: (_b = config.appId) !== null && _b !== void 0 ? _b : config.clientId, clientSecret: config.clientSecret, authorizationBaseUrl: (_d = (_c = config.authorizationBaseUrl) !== null && _c !== void 0 ? _c : config.authorizationEndpoint) !== null && _d !== void 0 ? _d : LINKEDIN_AUTH_URL, accessTokenEndpoint: (_f = (_e = config.accessTokenEndpoint) !== null && _e !== void 0 ? _e : config.tokenEndpoint) !== null && _f !== void 0 ? _f : LINKEDIN_TOKEN_URL, resourceUrl: (_g = config.resourceUrl) !== null && _g !== void 0 ? _g : LINKEDIN_RESOURCE_URL, responseType: (_h = config.responseType) !== null && _h !== void 0 ? _h : 'code', pkceEnabled: (_j = config.pkceEnabled) !== null && _j !== void 0 ? _j : true, scope });
};
const createOAuthState = () => [...crypto.getRandomValues(new Uint8Array(16))].map((b) => b.toString(16).padStart(2, '0')).join('');
export const buildLinkedInLoginOptions = (options = {}) => {
    var _a;
    const scope = (_a = options.scope) !== null && _a !== void 0 ? _a : options.scopes;
    const loginOptions = Object.assign(Object.assign(Object.assign({}, options), { providerId: LINKEDIN_PROVIDER_ID }), (scope === undefined ? {} : { scope }));
    // Bind convenience-redirect remapping to this OAuth state, not a generic sentinel.
    if (loginOptions.flow === 'redirect' && !loginOptions.state) {
        loginOptions.state = createOAuthState();
    }
    return loginOptions;
};
export const isLinkedInOAuthResult = (result) => result.provider === 'oauth2' && result.result.providerId === LINKEDIN_PROVIDER_ID;
export const asLinkedInLoginResult = (result) => ({
    provider: 'linkedin',
    result: result.result,
});
export const markLinkedInRedirectPending = (state) => {
    try {
        sessionStorage.setItem(LINKEDIN_REDIRECT_PENDING_KEY, state);
    }
    catch (_a) {
        // sessionStorage may be unavailable
    }
};
export const consumeLinkedInRedirectPending = (state) => {
    try {
        const pending = sessionStorage.getItem(LINKEDIN_REDIRECT_PENDING_KEY);
        sessionStorage.removeItem(LINKEDIN_REDIRECT_PENDING_KEY);
        return Boolean(pending && state && pending === state);
    }
    catch (_a) {
        return false;
    }
};
//# sourceMappingURL=linkedin-provider.js.map